const currentState = {
    masterFolders: null,
    masterChildrenFolders: null,
    meetingPacks: null,
    meetingChildrenPacks: null,
    dynamicFolders: null,
    dynamicChildrenFolders: null,
    companyGroups: null,
    folderRights: null,
    activeResource: null,
    activeResourcePermissions: null,
    activeJacket: null,
    activeJacketPermissions: null
};

const reducer = (state = currentState, action) => {
    switch (action.type) {
        case 'INSTANTIATE_MASTER_FOLDERS':
            return {
                ...state,
                masterFolders: action.payload
            };
        case 'UPDATE_MASTER_FOLDER_DETAILS': {
            const masterId = action.payload.id;
            const masterDetails = action.payload.details;
            const masterFoldersDuplicate = state.masterFolders;

            const index = masterFoldersDuplicate.findIndex(masterFolder => masterFolder.id === masterId);
            masterFoldersDuplicate[index] = masterDetails;
            return {
                ...state,
                masterFolders: masterFoldersDuplicate
            }

        }
        case 'RESET_MASTER_CHILDREN_FOLDERS':
            return {
                ...state,
                masterChildrenFolders: null
            }
        case 'INSTANTIATE_MASTER_CHILDREN_FOLDERS': {
            const masterkey = action.payload.master;
            const children = action.payload.children;
            const object = {};
            object[masterkey] = children
            let childrenFolders;
            if (state.masterChildrenFolders !== null) {
                const exists = state.masterChildrenFolders?.findIndex(master => masterkey in master)
                if (exists !== -1) {
                    state.masterChildrenFolders[exists][masterkey] = [...state.masterChildrenFolders[exists][masterkey], ...children];
                    childrenFolders = [...state.masterChildrenFolders];
                } else {
                    childrenFolders = [...state.masterChildrenFolders, object]
                }
            } else {
                childrenFolders = [object]
            }
            return {
                ...state,
                masterChildrenFolders: childrenFolders
            }
        };
        case 'INSTANTIATE_DYNAMIC_FOLDERS':
            return {
                ...state,
                dynamicFolders: action.payload
            };
        case 'UPDATE_DYNAMIC_FOLDER_DETAILS': {
            const dynamicId = action.payload.id;
            const dynamicDetails = action.payload.details;
            const dynamicFoldersDuplicate = state.dynamicFolders;

            const index = dynamicFoldersDuplicate.findIndex(dynamicFolder => dynamicFolder.id === dynamicId);
            dynamicFoldersDuplicate[index] = dynamicDetails;
            return {
                ...state,
                dynamicFolders: dynamicFoldersDuplicate
            }
        }
        case 'INSTANTIATE_MEETING_PACKS':
            return {
                ...state,
                meetingPacks: action.payload
            };
        case 'UPDATE_MEETING_PACK_FOLDER_DETAILS': {
            const meetingPackId = action.payload.id;
            const meetingPackDetails = action.payload.details;
            const meetingPackFoldersDuplicate = state.meetingPacks;

            const index = meetingPackFoldersDuplicate.findIndex(meetingPackFolder => meetingPackFolder.id === meetingPackId);
            meetingPackFoldersDuplicate[index] = meetingPackDetails;
            return {
                ...state,
                meetingPack: meetingPackFoldersDuplicate
            }
        }
        case 'SET_FOLDER_TO_MEETING_PACK': {
            const folderId = action.payload.id;
            const folderType = action.payload.type;
            let meetingPackFoldersDuplicate = state.meetingPacks;
            let returnState = {
                ...state,
                meetingPacks: state.meetingPacks,
                masterFolders: state.masterFolders
            }
            switch (folderType) {
                case 'static':
                    let staticFoldersDuplicate = Array.isArray(state.masterFolders) ? [...state.masterFolders] : null
                    if (staticFoldersDuplicate && meetingPackFoldersDuplicate) {
                        const folder = staticFoldersDuplicate.find(staticFolder => staticFolder.id?.toString() === folderId?.toString())
                        if (folder !== null && folder !== undefined) {
                            meetingPackFoldersDuplicate.push(folder)
                            staticFoldersDuplicate = staticFoldersDuplicate.filter(staticFolder => staticFolder.id?.toString() !== folderId?.toString())
                            if (meetingPackFoldersDuplicate.some(meetingPack => meetingPack.id?.toString() === folderId?.toString()) && !staticFoldersDuplicate.some(staticFolder => staticFolder.id?.toString() === folderId?.toString())) {
                                returnState = {
                                    ...state,
                                    meetingPacks: meetingPackFoldersDuplicate,
                                    masterFolders: staticFoldersDuplicate
                                }
                            }

                        }
                    }
                    break;
                case 'dynamic':
                    let dynamicFoldersDuplicate = Array.isArray(state.dynamicFolders) ? [...state.dynamicFolders] : null
                    if (dynamicFoldersDuplicate && meetingPackFoldersDuplicate) {
                        const folder = dynamicFoldersDuplicate.find(dynamicFolder => dynamicFolder.id?.toString() === folderId?.toString())
                        if (folder !== null && folder !== undefined) {
                            meetingPackFoldersDuplicate.push(folder)
                            dynamicFoldersDuplicate = dynamicFoldersDuplicate.filter(dynamicFolder => dynamicFolder.id?.toString() !== folderId?.toString())
                            if (meetingPackFoldersDuplicate.some(meetingPack => meetingPack.id?.toString() === folderId?.toString()) && !dynamicFoldersDuplicate.some(dynamicFolder => dynamicFolder.id?.toString() === folderId?.toString())) {
                                returnState = {
                                    ...state,
                                    meetingPacks: meetingPackFoldersDuplicate,
                                    masterFolders: dynamicFoldersDuplicate
                                }
                            }
                        }
                    }
                    break;
                default:
                    break;
            }
            return returnState;
        }
        case 'SET_FOLDER_TO_DYNAMIC_PACK': {
            const folderId = action.payload.id;
            const folderType = action.payload.type;
            let meetingPackFoldersDuplicate = state.meetingPacks;
            let returnState = {
                ...state,
                meetingPacks: state.meetingPacks,
                masterFolders: state.masterFolders
            }
            switch (folderType) {
                case 'static':
                    let staticFoldersDuplicate = Array.isArray(state.masterFolders) ? [...state.masterFolders] : null
                    if (staticFoldersDuplicate && meetingPackFoldersDuplicate) {
                        const folder = staticFoldersDuplicate.find(staticFolder => staticFolder.id?.toString() === folderId?.toString())
                        if (folder !== null && folder !== undefined) {
                            meetingPackFoldersDuplicate.push(folder)
                            staticFoldersDuplicate = staticFoldersDuplicate.filter(staticFolder => staticFolder.id?.toString() !== folderId?.toString())
                            if (meetingPackFoldersDuplicate.some(meetingPack => meetingPack.id?.toString() === folderId?.toString()) && !staticFoldersDuplicate.some(staticFolder => staticFolder.id?.toString() === folderId?.toString())) {
                                returnState = {
                                    ...state,
                                    meetingPacks: meetingPackFoldersDuplicate,
                                    masterFolders: staticFoldersDuplicate
                                }
                            }
                        }
                    }
                    break;
                case 'dynamic':
                    break;
                default:
                    break;
            }
            return returnState;
        }
        case 'INSTANTIATE_GROUPS_COMPANY':
            return {
                ...state,
                companyGroups: action.payload
            };
        case 'INSTANTIATE_RIGHTS':
            return {
                ...state,
                folderRights: action.payload
            };
        case 'INSTANTIATE_RESOURCE_JACKETS': {
            let resource;
            let resource2;
            let index;
            let index2

            if (state.masterFolders && state.masterFolders.some(master => master.id === action.payload.resourceId)) {
                const masters = [...state.masterFolders];

                index = masters.findIndex(master => master.id === action.payload.resourceId);
                resource = { ...masters[index] };

                resource.jackets = action.payload.jackets;
                masters[index] = resource;

                return {
                    ...state,
                    masterFolders: masters
                };
            }
            else if (state.dynamicFolders && state.dynamicFolders.some(dynamic => dynamic.id === action.payload.resourceId)) {
                const dynamics = [...state.dynamicFolders];

                index2 = dynamics.findIndex(dynamic => dynamic.id === action.payload.resourceId);
                resource2 = { ...dynamics[index] };

                resource2.jackets = action.payload.jackets;
                dynamics[index2] = resource;

                return {
                    ...state,
                    dynamicFolders: dynamics
                };
            }
            else {
                const packs = Object.assign([], state.meetingPacks);

                index = packs.findIndex(pack => pack.id === action.payload.resourceId);
                resource = { ...packs[index] };

                resource.jackets = action.payload.jackets;
                packs[index] = resource;

                return {
                    ...state,
                    meetingPacks: packs,
                };
            }
        }
        case 'INSTANTIATE_RESOURCE_DOCUMENTS': {
            let resource;
            let index;
            let resource2;

            if (state.masterFolders && state.masterFolders.some(master => master.id === action.payload.resourceId)) {
                const masters = [...state.masterFolders];

                index = masters.findIndex(master => master.id === action.payload.resourceId);
                resource = { ...masters[index] };

                resource.documents = action.payload.documents;
                masters[index] = resource;

                return {
                    ...state,
                    masterFolders: masters
                };
            }
            else if (state.dynamicFolders && state.dynamicFolders.some(dynamic => dynamic.id === action.payload.resourceId)) {
                const dynamics = [...state.dynamicFolders];

                resource2 = { ...dynamics[index] };

                resource2.jackets = action.payload.jackets;
                dynamics[index] = resource2;

                return {
                    ...state,
                    dynamicFolders: dynamics
                };
            }
            else {
                const packs = Object.assign([], state.meetingPacks);

                index = packs.findIndex(pack => pack.id === action.payload.resourceId);
                resource = { ...packs[index] };

                resource.documents = action.payload.documents;
                packs[index] = resource;

                return {
                    ...state,
                    meetingPacks: packs,

                };
            }
        }
        case 'CREATE_DOCUMENT_JACKET':
            let _resource;
            let _index;
            let jackets;
            let _resource2;
            let _index2;
            let jackets2;

            if (state.masterFolders && state.masterFolders.some(master => master.id === action.payload.resourceId)) {
                const masters = [...state.masterFolders];

                _index = masters.findIndex(master => master.id === action.payload.resourceId);
                _resource = { ...masters[_index] };
                jackets = Object.assign([], _resource.jackets);

                jackets.push(action.payload.jacket);
                _resource.jackets = jackets;
                masters[_index] = _resource;

                return {
                    ...state,
                    masterFolders: masters
                };
            }
            else if (state.dynamicFolders && state.dynamicFolders.some(dynamic => dynamic.id === action.payload.resourceId)) {
                const dynamics = [...state.dynamicFolders];

                _index2 = dynamics.findIndex(dynamic => dynamic.id === action.payload.resourceId);
                _resource2 = { ...dynamics[_index2] };

                _resource2.jackets = action.payload.jackets;
                jackets2 = Object.assign([], _resource2.jackets);

                jackets2.push(action.payload.jacket);
                _resource2.jackets = jackets;
                dynamics[_index2] = _resource2;

                return {
                    ...state,
                    dynamicFolders: dynamics
                };
            }
            else {
                const packs = Object.assign([], state.meetingPacks);

                _index = packs.findIndex(pack => pack.id === action.payload.resourceId);
                _resource = { ...packs[_index] };
                jackets = Object.assign([], _resource.jackets);

                jackets.push(action.payload.jacket);

                _resource.jackets = action.payload.jackets;
                packs[_index] = _resource;

                return {
                    ...state,
                    meetingPacks: packs,
                };
            }
        case 'DELETE_RESOURCE':
        case 'ARCHIVE_RESOURCE': {
            let index;
            let index2;
            if (state.masterFolders && state.masterFolders.some(master => parseInt(master.id) === parseInt(action.payload))) {
                const masters = [...state.masterFolders];
                index = masters.findIndex(master => parseInt(master.id) === parseInt(action.payload));

                masters.splice(index, 1);

                return {
                    ...state,
                    masterFolders: masters
                };
            }
            else if (state.dynamicFolders && state.dynamicFolders.some(dynamic => dynamic.id === action.payload.resourceId)) {
                const dynamics = [...state.dynamicFolders];

                index2 = dynamics.findIndex(dynamic => dynamic.id === action.payload.resourceId);
                dynamics.splice(index2, 1);

                return {
                    ...state,
                    dynamicFolders: dynamics
                };
            }
            else {
                const packs = Object.assign([], state.meetingPacks);

                index = packs.findIndex(pack => parseInt(pack.id) === parseInt(action.payload));
                packs.splice(index, 1);

                return {
                    ...state,
                    meetingPacks: packs,
                };
            }
        }
        case 'UPDATE_RESOURCE_SIZE':
            let resource_;
            let index_;
            let resource_2;

            if (state.masterFolders && state.masterFolders.some(master => master.id === action.payload.resourceId)) {
                const masters = [...state.masterFolders];

                index_ = masters.findIndex(master => master.id === action.payload.resourceId);
                resource_ = { ...masters[index_] };

                if (!action.payload.shrink) {
                    resource_.size = (parseFloat(resource_.size.split(' ')[0]) + parseFloat((action.payload.byValue / (10 ** 6)).toFixed(2))) + ' MB';
                } else {
                    resource_.size = null === action.payload.bySize ? '0.00 MB' : (parseFloat(resource_.size.split(' ')[0]) - parseFloat((action.payload.byValue / (10 ** 6)).toFixed(2))).toFixed(2) + ' MB';
                }

                if (parseFloat(resource_.size.split(' ')[0]) < 0)
                    resource_.size = '0.00 MB';

                masters[index_] = resource_;

                return {
                    ...state,
                    masterFolders: masters
                };
            }
            else if (state.dynamicFolders && state.dynamicFolders.some(dynamic => dynamic.id === action.payload.resourceId)) {
                const dynamics = [...state.dynamicFolders];

                resource_2 = { ...dynamics[index_] };

                if (!action.payload.shrink) {
                    resource_2.size = (parseFloat(resource_2.size.split(' ')[0]) + parseFloat((action.payload.byValue / (10 ** 6)).toFixed(2))) + ' MB';
                } else {
                    resource_2.size = null === action.payload.bySize ? '0.00 MB' : (parseFloat(resource_2.size.split(' ')[0]) - parseFloat((action.payload.byValue / (10 ** 6)).toFixed(2))).toFixed(2) + ' MB';
                }

                if (parseFloat(resource_2.size.split(' ')[0]) < 0)
                    resource_2.size = '0.00 MB';

                dynamics[index_] = resource_2;

                return {
                    ...state,
                    dynamicFolders: dynamics
                };
            }
            else {
                const packs = Object.assign([], state.meetingPacks);

                index_ = packs.findIndex(pack => pack.id === action.payload.resourceId);
                resource_ = { ...packs[index_] };

                if (!action.payload.shrink) {
                    resource_.size = (parseFloat(resource_.size.split(' ')[0]) + parseFloat((action.payload.byValue / (10 ** 6)).toFixed(2))) + ' MB';
                } else {
                    resource_.size = null === action.payload.bySize ? '0.00 MB' : (parseFloat(resource_.size.split(' ')[0]) - parseFloat((action.payload.byValue / (10 ** 6)).toFixed(2))).toFixed(2) + ' MB';
                }

                if (parseFloat(resource_.size.split(' ')[0]) < 0)
                    resource_.size = '0.00 MB';

                packs[index_] = resource_;

                return {
                    ...state,
                    meetingPacks: packs
                };
            }
        case 'CREATE_MASTER_FOLDER':
            const masterFolders = Object.assign([], state.masterFolders);
            masterFolders.unshift(action.payload);

            return {
                ...state,
                masterFolders: masterFolders
            };
        case 'CREATE_DYNAMIC_FOLDER':
            const dynamicFolders = Object.assign([], state.dynamicFolders);
            dynamicFolders.unshift(action.payload);

            return {
                ...state,
                dynamicFolders: dynamicFolders
            };
        case 'CREATE_MEETING_PACK':
            const meetingPacks = Object.assign([], state.meetingPacks);
            meetingPacks.unshift(action.payload);

            return {
                ...state,
                meetingPacks: meetingPacks
            };
        case 'RESET_RESOURCES':
            return {
                ...state,
                masterFolders: null,
                meetingPacks: null,
                dynamicFolders: null,
                companyGroups: null,
                activeResource: null
            };
        case 'SET_ACTIVE_RESOURCE': {
            const resource = action.payload;

            if (resource.jackets) delete resource.jackets;
            return {
                ...state,
                activeResource: resource
            }
        }
        case 'UNSET_ACTIVE_RESOURCE':
            return {
                ...state,
                activeResource: null
            }
        case 'SET_ACTIVE_JACKET':
            return {
                ...state,
                activeJacket: action.payload
            }
        case 'UNSET_ACTIVE_JACKET':
            return {
                ...state,
                activeJacket: null
            }
        case 'UPDATE_ACTIVE_RESOURCE_NAME': {
            let index;
            let resource;
            let resource2;
            const activeResource = Object.assign({}, state.activeResource);
            activeResource.name = action.payload;

            if (state.masterFolders && state.masterFolders.some(master => parseInt(master.id) === parseInt(activeResource.id))) {
                const masters = [...state.masterFolders];

                index = masters.findIndex(master => parseInt(master.id) === parseInt(activeResource.id));
                resource = { ...masters[index] };

                resource.name = action.payload;
                masters[index] = resource;

                return {
                    ...state,
                    masterFolders: masters,
                    activeResource: activeResource
                };
            }
            else if (state.dynamicFolders && state.dynamicFolders.some(dynamic => parseInt(dynamic.id) === parseInt(activeResource.id))) {
                const dynamics = [...state.dynamicFolders];

                resource2 = { ...dynamics[index] };

                resource2.name = action.payload;
                dynamics[index] = resource2;

                return {
                    ...state,
                    dynamicFolders: dynamics,
                    activeResource: activeResource
                };
            }
            else {
                const packs = [...state.meetingPacks];

                index = packs.findIndex(master => parseInt(master.id) === parseInt(activeResource.id));
                resource = { ...packs[index] };

                resource.name = action.payload;
                packs[index] = resource;

                return {
                    ...state,
                    meetingPacks: packs,
                    activeResource: activeResource
                };
            }
        }
        case 'UPDATE_ACTIVE_JACKET_NAME': {
            let resource;
            let jackets;
            let index;
            let jackets2;

            const jacket = Object.assign({}, state.activeJacket);
            jacket.name = action.payload;

            if (state.masterFolders && state.masterFolders.some(master => parseInt(master.id) === parseInt(state.activeResource.id))) {
                const masters = [...state.masterFolders];

                index = masters.findIndex(master => parseInt(master.id) === parseInt(state.activeResource.id));
                resource = { ...masters[index] };

                jackets = Object.assign([], resource.jackets);
                const i = jackets.findIndex(jacket => parseInt(jacket.id) === parseInt(state.activeJacket.id));

                if (i >= 0) {
                    const jacket = { ...jackets[i] };
                    jacket.name = action.payload;

                    jackets[i] = jacket;
                    resource.jackets = jackets;
                    masters[index] = resource;
                }

                return {
                    ...state,
                    masterFolders: masters,
                    activeJacket: jacket
                };
            }
            else if (state.dynamicFolders && state.dynamicFolders.some(dynamic => parseInt(dynamic.id) === parseInt(state.activeResource.id))) {
                const dynamics = [...state.dynamicFolders];

                index = dynamics.findIndex(dynamic => parseInt(dynamic.id) === parseInt(state.activeResource.id));
                resource = { ...dynamics[index] };

                jackets = Object.assign([], resource.jackets);
                const i = jackets2.findIndex(jacket => parseInt(jacket.id) === parseInt(state.activeJacket.id));

                if (i >= 0) {
                    const jacket = { ...jackets[i] };
                    jacket.name = action.payload;

                    jackets[i] = jacket;
                    resource.jackets = jackets;
                    dynamics[index] = resource;
                }

                return {
                    ...state,
                    dynamicFolders: dynamics,
                    activeJacket: jacket
                };
            }

            else {
                const packs = [...state.meetingPacks];

                index = packs.findIndex(pack => parseInt(pack.id) === parseInt(state.activeResource.id));
                resource = { ...packs[index] };

                jackets = Object.assign([], resource.jackets);
                const i = jackets.findIndex(jacket => parseInt(jacket.id) === parseInt(state.activeJacket.id));

                if (i >= 0) {
                    const jacket = { ...jackets[i] };
                    jacket.name = action.payload;

                    jackets[i] = jacket;
                    resource.jackets = jackets;
                    packs[index] = resource;
                }

                return {
                    ...state,
                    meetingPacks: packs,
                    activeJacket: jacket
                };
            }
        }
        case 'SET_ACTIVE_RESOURCE_PERMISSIONS':
            return {
                ...state,
                activeResourcePermissions: action.payload
            }
        case 'UNSET_ACTIVE_RESOURCE_PERMISSIONS':
            return {
                ...state,
                activeResourcePermissions: null
            }
        case 'SET_ACTIVE_JACKET_PERMISSIONS':
            return {
                ...state,
                activeJacketPermissions: action.payload
            }
        case 'UNSET_ACTIVE_JACKET_PERMISSIONS':
            return {
                ...state,
                activeJacketPermissions: null
            }
        default:
            return state;
    }
};

export default reducer;